export default {
  path: '/',
  name: 'FrontOffice',
  redirect: '/home',
  component: () => import('../layout/beneficiaries/LayoutFactory.vue'),
  meta: {
    title: 'Addviseo',
  },
  children: [
    {
      path: 'home',
      name: 'Home',
      redirect: '/home/appointment',
      component: () => import('../views/Beneficiary/Home/Home.vue'),
      meta: {
        title: 'Addviseo',
        pageTitle: 'Bienvenue !',
        layout: 'beneficiary',
      },
      children: [
        {
          path: 'appointment',
          name: 'HomeAppointment',
          component: () => import('../views/Beneficiary/Home/Appointment.vue'),
        },
        {
          path: 'search-criterias',
          name: 'HomeSearchCriteria',
          component: () => import('../views/Beneficiary/Home/SearchCriteria.vue'),
          meta: {
            pageTitle: 'Mes critères de recherche',
          },
        },
        {
          path: 'career',
          name: 'HomeCareer',
          component: () => import('../views/Beneficiary/Home/Career.vue'),
          meta: {
            pageTitle: 'Mon parcours pro',
          },
        },
        {
          path: 'skills',
          name: 'HomeSkills',
          component: () => import('../views/Beneficiary/Home/Skills.vue'),
          meta: {
            pageTitle: 'Mes compétences',
          },
        },
        {
          path: 'resumes',
          name: 'HomeResumes',
          component: () => import('../views/Beneficiary/Home/Resumes.vue'),
          meta: {
            pageTitle: 'Mes CV',
          },
        },
      ],
    },
    {
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('../views/Beneficiary/Dashboard/Dashboard.vue'),
      meta: {
        title: 'Tableau de bord',
        pageTitle: 'Tableau de bord',
        layout: 'beneficiary',
      },
    },
    {
      path: 'opportunities',
      name: 'Opportunities',
      meta: {
        title: "Mes opportunités d'emploi",
        pageTitle: "Mes opportunités d'emploi",
        layout: 'beneficiary',
      },
      children: [
        {
          path: '',
          name: 'OpportunitiesList',
          component: () => import('../views/Beneficiary/Opportunities/Opportunities.vue'),
        },
        {
          path: ':source/:id',
          name: 'OpportunitySheet',
          component: () => import('../views/Beneficiary/OpportunitySheet/Sheet.vue'),
        },
      ],
    },
    {
      path: 'onboarding',
      name: 'Onboarding',
      component: () => import('../views/Onboarding/OnboardingView.vue'),
      meta: {
        title: 'Onboarding',
        layout: 'onboarding',
      },
    },
    {
      path: 'toolbox',
      name: 'Toolbox',
      component: () => import('../views/Beneficiary/Toolbox.vue'),
      meta: {
        title: 'Ma boîte à outils',
        pageTitle: 'Ma boîte à outils',
        layout: 'beneficiary',
      },
    },
  ],
};
